module.exports = __webpack_public_path__ + "static/media/soumyajit_das.aa4f60cc.png";